import LinksBar from "./LinksBar";
import Project from "./Project";
const Projects: React.FC = () => {
  return (
    <div className="flex p-3" id="projects">
      <div className="hidden sm:sticky sm:top-3 sm:flex sm:h-fit">
        <LinksBar />
      </div>
      <div className="projects">
        <div className="lg:w-11/12">
          <h1 className="projectsHeader m-3">PERSONAL PROJECTS</h1>
          {/* <span id="projectsOverviewText">
            <p>
              Below are some of the projects that I have worked on in the past
              few years. These projects are far from perfect, and most are
              filled with bugs, flaws in design, and inefficiences, that I grow
              increasingly aware of as I become a more knowledgeable programmer.
              My primary intention with each of these projects was not to create
              something actually useful, but merely to provide an opportunity to
              gain a deeper understanding of various frameworks. Most of the
              languages, frameworks, and libraries used in these projects were
              completely new to me when I first began them—and although I am
              still far from an expert, I hope to continously become more and
              more proficient.
              <p>
                Each project has a link to a detailed writeup including
                additional images, my initial intention, development process,
                and the lessons that I have learned since.
              </p>
            </p>
          </span> */}
          <div className="projectsContainer flex flex-col gap-10">
          <Project
              projectType={"FULL STACK WEB DEVELOPMENT"}
              name="CarpoolNU"
              date="Jan. 2023 — Sep. 2023"
              description="Contributed to CarpoolNU, a web app that connects Northeastern University students for carpooling in the Boston area."
              toolsUsed="Next,js, React.js, TypeScript, MySQL, TailwindCSS , TRPC, Prisma"
              image="/res/carpool/carpool.png"
              // writeupUrl={"papertrademern"}
              githubUrl={"https://github.com/sandboxnu/nucarpool"}
            />
            <Project
              projectType={"FULL STACK WEB DEVELOPMENT"}
              name="Emotion Diary"
              date="April. 2023 — Aug. 2023"
              description="Developed web app enabling users to record emotional events, providing insight into their emotional patterns and mental well-being."
              toolsUsed="Next,js, React.js, TypeScript, MySQL, TailwindCSS , TRPC, Prisma"
              image="/res/emotiondiary/calendar.png"
              // writeupUrl={"papertrademern"}
              githubUrl={"https://github.com/jun-w-huang/emotion-diary"}
            />
            
            <Project
              projectType={"FULL STACK WEB DEVELOPMENT"}
              name="Paper Trade"
              date="Dec. 2021 — Aug. 2022"
              description="Created a website allowing users to practice investing in stocks using real-time prices but fictional money. 
          Displays portfolio performance graphically using charts, enabling users to visually view their portfolio diversity. 
          "
              toolsUsed="React, MongoDB, TypeScript, JSX, CSS, ExpressJS, NodeJS"
              image="/res/papertradeweb/dashboard.png"
              writeupUrl={"papertrademern"}
              githubUrl={"https://github.com/jun-w-huang/paper-trade"}
            />
            {/* <Project
            projectType={"FRONTEND WEB DEVELOPMENT"}
            name="Flow In The Field Frontend"
            date="Dec. 2022"
            description="Built frontend of a language learning game which assists players to practice learning languages through translating words.  
          "
            toolsUsed="React, TypeScript, JSX, CSS"
            image="/res/flowinthefield/resultsscreen.png"
            // writeupUrl={"flowinthefieldfrontend"}
            // githubUrl={"https://github.com/jun-w-huang/flowinthefieldfrontend"}
          /> */}
            <Project
              projectType={"JAVA SWING APPLICATION"}
              name="Image Editor"
              date="July 2022"
              description="Constructed standalone application allowing users to 
          load, edit, and save images though GUI. Additionally displays a histogram 
          representing an image’s color distribution. Features over 15 distinct 
          image editing tools such as blur, sharpen, stretching, and color transformations."
              toolsUsed="Java, Swing GUI"
              image="/res/imageeditor/loaded.png"
              // writeupUrl={"imageeditor"}
            />
            <Project
              projectType={"FULL STACK WEB DEVELOPMENT"}
              name="Beatshuffler"
              date="July 2021 — Aug. 2021"
              description="A way for users to easily upload and share their music online. "
              toolsUsed="Python, HTML, CSS, JavaScript, Django, SQLite."
              image="/res/beatshuffler/home.png"
              // writeupUrl="beatshuffler"
            />
            <Project
              projectType={"STANDALONE PYTHON TKINTER APP"}
              name="Networth Calculator"
              date="July 2021"
              description="Standalone application allowing users to input financial holdings 
          such as cryptocurrency and stocks whose values are then tracked 
          overtime via comparison to real-time prices.
          ."
              toolsUsed="Python, Tkinter."
              image="/res/networthcalculator/main.png"
              // writeupUrl="networthcalculator"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Projects;
